import { VARIANTS } from 'shared_DEPRECATED/components/Button/config';

export const routeNames = {
  GOALS: 'goals',
  PLANNING: 'sprint-planning',
  SPRINTS_DASHBOARD: 'sprints',
  CHALLENGE_TRACKING: 'challenge-tracking',
  CORTEX_CHAT: 'cortex-chat',
  CONNECTIONS: 'users',
  COACH: 'hde',
  ADMIN: 'admin',
  SESSIONS: 'sessions',
  GROUPS: 'groups',
  RESOURCE_BANK: 'resource-bank',
};

export const DAILY_STATUS_VALUES = {
  SUCCESS: 'success',
  FAIL: 'fail',
  EMPTY: 'empty',
  PASS: 'pass',
} as const;

export const DAILY_STATUSES = [
  DAILY_STATUS_VALUES.SUCCESS,
  DAILY_STATUS_VALUES.FAIL,
  DAILY_STATUS_VALUES.EMPTY,
];

export const WEEK_TARGET_ABSENT = 0;

export const btnVariantIconColors = {
  critical: 'var(--white)',
  primary: 'var(--white)',
  secondary: 'var(--black)',
  tertiary: 'var(--black)',
  symbol: 'var(--black)',
} as { [key in VARIANTS]?: string };

export const API_STATUSES = {
  ERROR: 'error',
  LOADING: 'loading',
  SUCCESS: 'success',
};
